import * as AppConstants from '../../app/AppConstants';

const initialState = () => ({
  themes: {},
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.THEME__LOAD_FINISHED: {
      const {themeId, theme} = action.payload;
      const themeAndPalette = {
        ...theme,
        resolvedPalette: action.payload.chartPalette,
      };

      return {
        ...state,
        themes: {
          ...state.themes,
          [themeId]: {
            ...themeAndPalette,
          },
        },
      };
    }
    default:
      return state;
  }
};
